export default "/assets/images/smiling-girl-2.509fc94cbbb5e89a.webp";